import { useState } from 'react';
import { Box, IconButton, Snackbar, Typography } from '@mui/material';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import { walletApi } from '../../../services/api/walletApi';
import '../accountTheme.css';
import './BankAccountsScreen.css';

const maskAccount = (value) => {
  if (!value || value.length < 6) return value;
  return `${value.slice(0, 4)}****${value.slice(-4)}`;
};

function BankAccountsScreen({
  onBack,
  onOpenAddBank,
  bankAccounts,
  selectedBankId,
  onSelectBank,
  onAccountsChange,
}) {
  const [toast, setToast] = useState('');
  const selected =
    bankAccounts.find((a) => a.id === selectedBankId) || bankAccounts[0] || null;

  const setDefault = async (id) => {
    try {
      await walletApi.setDefaultBankAccount(id);
      onSelectBank?.(id);
      onAccountsChange?.();
      setToast('Default bank account updated');
    } catch (err) {
      setToast(err.message || 'Could not update default account');
    }
  };

  const removeAccount = async (id) => {
    if (!window.confirm('Remove this bank account?')) return;
    try {
      await walletApi.deleteBankAccount(id);
      onAccountsChange?.();
      setToast('Bank account removed');
    } catch (err) {
      setToast(err.message || 'Could not remove bank account');
    }
  };

  return (
    <Box className="bz-page">
      <Snackbar open={!!toast} autoHideDuration={3500} onClose={() => setToast('')} message={toast} />
      <Box className="bz-topbar">
        <IconButton size="small" onClick={onBack} className="bz-back-btn">
          <ArrowBackIosNewRoundedIcon fontSize="small" />
        </IconButton>
        <Typography className="bz-topbar__title">Bank accounts</Typography>
        <Box sx={{ width: 32 }} />
      </Box>

      <Box className="bz-scroll">
        {bankAccounts.length > 0 && (
          <Box className="bank-chips">
            {bankAccounts.map((a) => (
              <button
                key={a.id}
                type="button"
                className={`bank-chip ${selected?.id === a.id ? 'active' : ''}`}
                onClick={() => onSelectBank?.(a.id)}
              >
                {a.bankName}
              </button>
            ))}
          </Box>
        )}

        {selected ? (
          <Box className="bz-card bank-detail-card">
            <AccountBalanceRoundedIcon sx={{ fontSize: 36, color: '#60a5fa', mb: 1 }} />
            <Box className="bank-detail-row">
              <span>Bank</span>
              <span>{selected.bankName}</span>
            </Box>
            <Box className="bank-detail-row">
              <span>Account</span>
              <span>{maskAccount(selected.accountNumber)}</span>
            </Box>
            <Box className="bank-detail-row">
              <span>IFSC</span>
              <span>{selected.ifscCode}</span>
            </Box>
            <Box className="bank-detail-row">
              <span>Holder</span>
              <span>{selected.accountHolderName}</span>
            </Box>
            <Box className="bank-detail-row">
              <span>Phone</span>
              <span>{selected.phoneNumber}</span>
            </Box>
            <Box className="bank-account-actions">
              {!selected.isDefault && (
                <button type="button" className="bank-action-btn" onClick={() => setDefault(selected.id)}>
                  Set as default
                </button>
              )}
              {selected.isDefault && (
                <Typography className="bank-default-badge">Default account</Typography>
              )}
              <button
                type="button"
                className="bank-action-btn bank-action-btn--danger"
                onClick={() => removeAccount(selected.id)}
              >
                Remove
              </button>
            </Box>
          </Box>
        ) : (
          <Typography className="bz-empty">No bank account added yet</Typography>
        )}

        <button type="button" className="bank-add-btn" onClick={onOpenAddBank}>
          + Add bank account
        </button>
      </Box>
    </Box>
  );
}

export default BankAccountsScreen;
